import React, { Component } from "react";
import { connect } from 'react-redux';

import classes from "./Flights.scss";
import moment from 'moment';

import { Events, animateScroll as scroll } from 'react-scroll'

import Flight from "../../components/Flight/Flight/Flight";
import BookingEngineFlights from '../../containers/FlightBookingEngine/FlightBookingEngine';
import SearchResultWrapper from '../../components/UI/Wrappers/SearchResultWrapper/SearchResultWrapper';

import * as flightActions from '../../store/actions/index';
import * as navigationActions from '../../store/actions/index';
import * as lowestFareActions from '../../store/actions/index';
import * as farePriceActions from '../../store/actions/index';

import LoadingBar from '../../components/UI/LoadingBar/LoadingBar';
import Media from 'react-media';

class Flights extends Component {

  componentDidMount() {
    this.props.onHideSideNavigation();
    this.props.onClearFlightData();
    this.props.onResetFarePrice();
    const params = new URLSearchParams(this.props.location.search);

    if (params.get('originCountry') !== 'IN' || params.get('destinationCountry') !== 'IN') {
      this.props.onGetIntFlights(this.props.location.search);
    } else {
      this.props.onGetFlights(this.props.location.search);
    }
    Events.scrollEvent.register('begin');
    Events.scrollEvent.register('end');
  }

  componentWillUnmount() {
    Events.scrollEvent.remove('begin');
    Events.scrollEvent.remove('end');
  }

  scrollToTop = () => {
    scroll.scrollToTop();
  }

  componentWillUpdate(nextProps) {
    const params = new URLSearchParams(nextProps.location.search);
    if (this.props.location.key !== nextProps.location.key) {
      this.props.onSetLoading();
      this.props.onHideSideNavigation();
      if (params.get('originCountry') !== 'IN' || params.get('destinationCountry') !== 'IN') {
        this.props.onGetIntFlights(nextProps.location.search);
      } else {
        this.props.onGetFlights(nextProps.location.search);
      }
    }
    if (this.props.loading) {      
      let lowestFareParams = [];
      lowestFareParams.push("origin=" + params.get("origin"));
      lowestFareParams.push("destination=" + params.get("destination"));
      lowestFareParams.push("tripType=" + params.get("type"));
      lowestFareParams.push("airlines=all");
      lowestFareParams.push("src=srp");
      let date = params.get("flight_depart_date");
      const newDate = moment(date, "DD/MM/YYYY").format('YYYY-MM-DD');
      lowestFareParams.push("from=" + moment(params.get("flight_depart_date"), 'DD/MM/YYYY').format('DD-MM-YYYY'));
      const toDate = moment(new Date(moment(newDate, 'YYYY-MM-DD').add(6, 'days'))).format('DD-MM-YYYY');
      lowestFareParams.push("to=" + toDate);
      const lowestFareParamsString = lowestFareParams.join("&");
      this.props.onGetLowestFare(lowestFareParamsString);
    } 
  }

  departPrevDateHandler = () => {
    let params = new URLSearchParams(this.props.location.search);
    const departDate = params.get("flight_depart_date") || "";
    params.set(
      "flight_depart_date",
      moment(departDate, "DD/MM/YYYY")
        .subtract(1, "days")
        .format("DD/MM/YYYY")
    );
    const updatedParams = decodeURIComponent(params.toString());

    this.props.history.push({
      pathname: "search",
      search: "?" + updatedParams
    });
  };

  departNextDateHandler = () => {
    let params = new URLSearchParams(this.props.location.search);
    const departDate = params.get("flight_depart_date");
    params.set(
      "flight_depart_date",
      moment(departDate, "DD/MM/YYYY")
        .add(1, "days")
        .format("DD/MM/YYYY")
    );
    const updatedParams = decodeURIComponent(params.toString());

    this.props.history.push({
      pathname: "search",
      search: "?" + updatedParams
    });
  };

  returnPrevDateHandler = () => {
    let params = new URLSearchParams(this.props.location.search);
    const arrivalDate = params.get("arrivalDate") || "";
    params.set(
      "arrivalDate",
      moment(arrivalDate, "DD/MM/YYYY")
        .subtract(1, "days")
        .format("DD/MM/YYYY")
    );
    const updatedParams = decodeURIComponent(params.toString());

    this.props.history.push({
      pathname: "search",
      search: "?" + updatedParams
    });
  };

  returnNextDateHandler = () => {
    let params = new URLSearchParams(this.props.location.search);
    const arrivalDate = params.get("arrivalDate") || "";
    params.set(
      "arrivalDate",
      moment(arrivalDate, "DD/MM/YYYY")
        .add(1, "days")
        .format("DD/MM/YYYY")
    );
    const updatedParams = decodeURIComponent(params.toString());

    this.props.history.push({
      pathname: "search",
      search: "?" + updatedParams
    });
  };

  render() {
    const params = new URLSearchParams(this.props.location.search);
    document.querySelector('html').style.overflow = (window.innerWidth <= 900 && (this.props.mobileFiltersToggle || this.props.mobileBookingEngine)) ? 'hidden' : null;
    document.querySelector('body').style.overflow = (window.innerWidth <= 900 && (this.props.mobileFiltersToggle || this.props.mobileBookingEngine)) ? 'hidden' : null;
    document.querySelector('#root').style.overflow = (window.innerWidth <= 900 && (this.props.mobileFiltersToggle || this.props.mobileBookingEngine)) ? 'hidden' : null;

    let flights = null;

    if (this.props.type) {
      flights = 
      <Flight
        flightType={params.get('originCountry') !== 'IN' || params.get('destinationCountry') !== 'IN' ? 'INT' : 'DOM'} 
        type={this.props.type} 
        scrollTop={this.scrollToTop} 
        departPrev={this.departPrevDateHandler}
        departNext={this.departNextDateHandler}
        returnPrev={this.returnPrevDateHandler}
        returnNext={this.returnNextDateHandler} />
    }

    return (
        <SearchResultWrapper>
            <React.Fragment>
              { this.props.barLoading ? <LoadingBar/> : null }
              <Media query="(max-width: 900px)">
                {matches =>
                  matches ? (
                    <div 
                      style={{marginBottom: 'none', borderBottomLeftRadius: '1.2rem', borderBottomRightRadius: '1.2rem'}} 
                      className={[classes.MobileBookingEngine, this.props.mobileBookingEngine ? classes.ToggleMobileBookingEngine : null, (window.innerWidth > 600 && window.innerWidth < 900 && this.props.mobileBookingEngine) ? classes.TabletBookingEngine : null].join(' ')}>
                        <BookingEngineFlights />
                      </div>
                    ) : null }
              </Media>
              {/* <Media query="(max-width: 900px)">
                    {matches =>
                      matches && this.props.mobileBookingEngine ? <Overlay /> : null}
              </Media>
              <Media query="(max-width: 900px)">
                    {matches =>
                      matches && this.props.mobileFiltersToggle ? <Overlay /> : null}
              </Media>
              <Media query="(min-width: 600px) and (max-width: 900px)">
                    {matches =>
                      matches && this.props.tabletBookingEngine ? <Overlay /> : null}
              </Media> */}
                {flights}
            </React.Fragment>
        </SearchResultWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    type: state.flights.flightType,
    loading: state.flights.loading,
    barLoading: state.flights.barLoading,
    tabletBookingEngine: state.ui.tabletBookingEngine,
    mobileFiltersToggle: state.ui.mobileFiltersToggle,
    mobileBookingEngine: state.ui.mobileBookingEngine,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onGetFlights: (flightSearchParams) => dispatch(flightActions.getFlights(flightSearchParams)),
    onGetIntFlights:  (flightSearchParams) => dispatch(flightActions.getIntFlights(flightSearchParams)),
    onSetLoading: () => dispatch(flightActions.setLoading()),
    onHideSideNavigation: () => dispatch(navigationActions.hideSideNavigation()),
    onGetLowestFare: (lowestFareParams) => dispatch(lowestFareActions.getLowestFare(lowestFareParams)),
    onClearFlightData: () => dispatch(flightActions.clearFlightsData()),
    onResetFarePrice: () => dispatch(farePriceActions.resetFarePrice()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)((Flights));



// WEBPACK FOOTER //
// ./src/containers/Flights/Flights.js